"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderFacesRead = exports.renderFaceRead = void 0;
const face_dimensions_1 = require("./face-dimensions");
const get_face_size_and_angle_1 = require("./get-face-size-and-angle");
const draw_rotated_rect_1 = require("./drawing/draw-rotated-rect");
const create_angular_coordinate_system_1 = require("./drawing/create-angular-coordinate-system");
/**
 * Render a FaceRead onto a canvas rendering context.
 * @param ctx
 * @param faceRead
 */
const renderFaceRead = (ctx, faceRead, options = {}) => {
    const faceDimensions = (0, get_face_size_and_angle_1.getFaceSizeAndAngle)(faceRead);
    if (faceDimensions == null) {
        return;
    }
    const { faceSizeInPixels, angleInRadians } = faceDimensions;
    const { center, underline, overline } = faceRead;
    const { lineThicknessAfFractionOfFaceSize = 0.02, errorLineThicknessAsFractionOfFaceSize = lineThicknessAfFractionOfFaceSize * 2, colorIndicatingCorrectness = "rgba(0,255,0,0.5)", colorIndicatingSmallError = "rgba(207, 83, 0,0.75)", colorIndicatingLargeError = "rgba(255,32,32,.75)", drawFaceOutlineRectangleIfFaceReadWithErrors = true, } = options;
    const coordinateSystemFromCenterOfDie = (0, create_angular_coordinate_system_1.createAngularCoordinateSystem)(center, angleInRadians);
    const undoverlineLength = faceSizeInPixels * face_dimensions_1.FaceDimensionsFractional.undoverlineLength;
    const undoverlineThickness = faceSizeInPixels * face_dimensions_1.FaceDimensionsFractional.undoverlineThickness;
    const centerOfUndoverlineToCenterOfFace = face_dimensions_1.FaceDimensionsFractional.centerOfUndoverlineToCenterOfFace * faceSizeInPixels;
    const defaultLineThickness = 1 + Math.floor(lineThicknessAfFractionOfFaceSize * faceSizeInPixels);
    const errorLineThickness = 1 + Math.floor(errorLineThicknessAsFractionOfFaceSize * faceSizeInPixels);
    const { errors } = faceRead;
    const hasErrors = errors != null && errors.length > 0;
    ctx.lineWidth = errorLineThickness;
    ctx.fillStyle = ctx.strokeStyle =
        (!hasErrors) ?
            colorIndicatingCorrectness :
            (errors.length == 1 && errors[0] != null && errors[0].type === "undoverline-bit-mismatch" && errors[0].hammingDistance <= 2) ?
                colorIndicatingSmallError :
                colorIndicatingLargeError;
    // Draw a rectangle around the face if an error has been found
    if (hasErrors && drawFaceOutlineRectangleIfFaceReadWithErrors) {
        (0, draw_rotated_rect_1.drawRotatedRect)(ctx, center, faceSizeInPixels, faceSizeInPixels, angleInRadians);
        ctx.stroke();
    }
    const underlineError = (errors && errors.length > 0 && errors[0] != null && errors[0].type === "undoverline-bit-mismatch" && errors[0].location === "underline");
    const overlineError = (errors && errors.length > 0 && errors[0] != null && errors[0].type === "undoverline-bit-mismatch" && errors[0].location === "overline");
    if (underline) {
        const underlineCenter = coordinateSystemFromCenterOfDie.pointAtAsXy({ x: 0, y: centerOfUndoverlineToCenterOfFace });
        (0, draw_rotated_rect_1.drawRotatedRect)(ctx, underlineCenter, undoverlineLength, undoverlineThickness, angleInRadians);
        ctx.stroke();
    }
    if (overline) {
        const overlineCenter = coordinateSystemFromCenterOfDie.pointAtAsXy({ x: 0, y: -centerOfUndoverlineToCenterOfFace });
        (0, draw_rotated_rect_1.drawRotatedRect)(ctx, overlineCenter, undoverlineLength, undoverlineThickness, angleInRadians);
        ctx.stroke();
    }
    const fontString = `bold ${faceSizeInPixels * face_dimensions_1.FaceDimensionsFractional.fontSize}px Inconsolata,monospace`;
    ctx.font = fontString;
    const distanceToBaseline = face_dimensions_1.FaceDimensionsFractional.textBaselineY - face_dimensions_1.FaceDimensionsFractional.center;
    if (faceRead.letter) {
        ctx.save();
        ctx.translate(...coordinateSystemFromCenterOfDie.pointAtAsTuple({
            x: -faceSizeInPixels * face_dimensions_1.FaceDimensionsFractional.textRegionWidth / 2,
            y: faceSizeInPixels * distanceToBaseline
        }));
        ctx.rotate(angleInRadians);
        ctx.fillText(faceRead.letter, 0, 0);
        ctx.restore();
    }
    if (faceRead.digit) {
        ctx.save();
        ctx.translate(...coordinateSystemFromCenterOfDie.pointAtAsTuple({
            x: faceSizeInPixels * face_dimensions_1.FaceDimensionsFractional.spaceBetweenLetterAndDigit / 2,
            y: faceSizeInPixels * distanceToBaseline
        }));
        ctx.rotate(angleInRadians);
        ctx.fillText(faceRead.digit, 0, 0);
        ctx.restore();
    }
};
exports.renderFaceRead = renderFaceRead;
const renderFacesRead = (ctx, facesRead, options) => facesRead.forEach(face => (0, exports.renderFaceRead)(ctx, face, options));
exports.renderFacesRead = renderFacesRead;
//# sourceMappingURL=render-faces-read.js.map